import React, { Component } from 'react';
import { Button } from 'semantic-ui-react'

class notfoundpage extends Component {


  render() {

    return (
      <div style={{top: '200px', position: 'relative', fontSize: '30px', fontWeight: '600'}} >
        Page not found. Click button to redirect to landing <br/>
        <div style={{marginTop: '10px'}}><a href="/test"><Button>Click Me!</Button></a></div>
      </div>
    );
  }
}

export default notfoundpage;



// WEBPACK FOOTER //
// ./src/pages/notfound.js